/*
 * this bridge preserves jquery tooltips before bootstrap clobbers them.
 * must be included after jquery ui and before bootstrap.
 * accessible via $(selector).uitooltip({..});
 */
$.widget.bridge('uitooltip', $.ui.tooltip);
